
import React from 'react';
import { Link } from "@fluentui/react-components";

interface TruncateProps {
    text: string;
    maxLength: number;
}

const TruncateText: React.FC<TruncateProps> = ({
                                                   text,
                                                   maxLength,
                                               }) => {

    if (text === null) {
        return null;
    }

    const truncatedText =
        text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

    return (
        <div
        >
            <Link
                href={text}
                target="_blank"
                rel="noopener noreferrer"
            >
                {truncatedText}
            </Link>
        </div>
    );
};

export default TruncateText;